import React, { Component } from 'react';
import images from './images';
import './styles.css';

class WelcomeHeader extends Component {
	render() {
		return (
			<div className='welcome-header'>
				<img style={{
					width: '163px'
				}} src={images['bocconi']} alt={images['bocconi']} />
				<img className='built_logo_ext' src={images['built_logo_ext']} alt={images['built_logo_ext']} />

			</div>
		);
	}
}


export default WelcomeHeader;
